import request from '@/utils/request'

//电商活动列表
export function getActivityList(data) {
    return request({
        url: '/backend/ProductActivity/getActivityList',
        method: 'post',
        data: data
    })
}

//创建修改打卡
export function createActivity(data) {
    return request({
        url: '/backend/ProductActivity/createActivity',
        method: 'post',
        data: data
    })
}

//获取打卡详情基本信息
export function getActivityInfo(data) {
    return request({
        url: '/backend/ProductActivity/getActivityInfo',
        method: 'post',
        data: data
    })
}

//修改电商活动状态
export function updateStatus(data) {
    return request({
        url: '/backend/ProductActivity/updateActivityStatus',
        method: 'post',
        data: data
    })
}



//获取活动关联课程列表
export function activityProductList(data) {
    return request({
        url: '/backend/ProductActivity/getActivityProductList',
        method: 'post',
        data: data
    })
}

//获取商品列表
export function getProductList(data) {
    return request({
        url: '/backend/ProductActivity/getProductList',
        method: 'post',
        data: data
    })
}

//电商添加商品
export function activityAddProduct(data) {
    return request({
        url: '/backend/ProductActivity/activityAddProduct',
        method: 'post',
        data: data
    })
}

//电商商品删除
export function activityDeleteProduct(data) {
    return request({
        url: '/backend/ProductActivity/activityDeleteProduct',
        method: 'post',
        data: data
    })
}

//电商活动订单列表
export function activityOrderList(data) {
    return request({
        url: '/backend/ProductActivity/activityOrderList',
        method: 'post',
        data: data
    })
}

//获取sku列表
export function getSkuList(data){
    return request({
        url: '/backend/ProductActivity/getSkuList',
        method: 'post',
        data: data
    })
}

//获取冲突商品列表
export function getConflictActivity(data){
    return request({
        url: '/backend/ProductActivity/getConflictActivity',
        method: 'post',
        data: data
    })
}
